import { DatePipe } from '@angular/common';
import { ErrorHandler, Injectable, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';

import { ContextEffects } from '@store/context/context.effects';
import { metaReducers, reducers } from '@store/index';
// import { DeviceDetectorModule } from 'ngx-device-detector';
import { AppComponent } from './app.component';
import { AppErrorHandler } from './error-handler';

import { MbCardModule, MoebiusUIModule } from '@am/moebius';
import { AmSearchBoxModule } from '@am/search-box';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { ParamsSerializer } from '@store/router/router-serializer';
import { environment } from '../environments/environment';

import { AmExpertsToolsControlModule } from '@am/experts-tools-control';
import { AmTripsAddProductModule } from '@am/trips-add-product';
import {
  HAMMER_GESTURE_CONFIG,
  HammerGestureConfig,
  HammerModule,
} from '@angular/platform-browser';
import * as Hammer from 'hammerjs';
import { registerLocaleData } from '@angular/common';
import localeEsAr from '@angular/common/locales/es-AR';

registerLocaleData(localeEsAr);

@Injectable()
export class HammerConfig extends HammerGestureConfig {
  buildHammer(element: HTMLElement) {
    return new Hammer(element, {
      inputClass: Hammer.TouchInput,
      touchAction: 'pan-y',
    });
  }
}

const runtimeChecksCustom = !environment.production
  ? {
      strictActionSerializability: true,
      strictActionTypeUniqueness: true,
      strictActionWithinNgZone: true,
      strictStateSerializability: true,
    }
  : {};

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    MoebiusUIModule,
    AmSearchBoxModule,
    SharedModule,
    AmExpertsToolsControlModule,
    HammerModule,
    StoreModule.forRoot(reducers, {
      metaReducers,
      runtimeChecks: {
        ...runtimeChecksCustom,
        strictActionImmutability: true,
        strictStateImmutability: true,
      },
    }),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    EffectsModule.forRoot([ContextEffects]),
    AppRoutingModule,
    StoreRouterConnectingModule.forRoot({
      serializer: ParamsSerializer,
    }),
    MbCardModule,
    AmTripsAddProductModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es-AR' },
    DatePipe,
    { provide: HAMMER_GESTURE_CONFIG, useClass: HammerConfig },
    { provide: ErrorHandler, useClass: AppErrorHandler },
    {
      provide: 'analytics-category-token',
      useValue: 'HTL|Results',
    },
    {
      provide: 'autocomplete-base-token',
      useValue: '/autocomplete',
    },
    {
      provide: 'destination-base-token',
      useValue: '/api/destination',
    },
  ],
  // tslint:disable-next-line: object-literal-sort-keys
  bootstrap: [AppComponent],
})
export class AppModule {}
